import { render } from "./singleChatListCard.vue?vue&type=template&id=47f2cb92&scoped=true"
import script from "./singleChatListCard.vue?vue&type=script&lang=js"
export * from "./singleChatListCard.vue?vue&type=script&lang=js"

import "./singleChatListCard.vue?vue&type=style&index=0&id=47f2cb92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f2cb92"]])

export default __exports__